import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import StepItem from './StepItem'
import useDeviceDetect from '../../../../../common/hooks/useDeviceDetect'
import { setDotsClassName } from '../../../../../common/helpers'

const SlickSlider = dynamic(() =>
  import('../../../../shared/BrandPages/SlickSlider')
)
const FiveSteps = ({ steps, primaryBtnClassName, primaryBtnName }) => {
  const { isMobile } = useDeviceDetect(true)

  const settings = {
    dots: true,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (current) => {
      setDotsClassName(current, document, 'slider-debt-relief-steps')
    },
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          speed: 100,
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <section
      className="col-span-full bg-blue-base-white"
      data-testid="how-it-works-five-steps"
    >
      {!isMobile ? (
        steps.map((step, index) => (
          <StepItem
            key={index}
            item={step}
            isMobile={isMobile}
            stepNumber={index + 1}
            reverse={index % 2 !== 0}
            primaryBtnClassName={primaryBtnClassName}
            primaryBtnName={primaryBtnName}
          />
        ))
      ) : (
        <SlickSlider
          sliderSettings={settings}
          dotsClassName="pb-5"
          name="debt-relief-steps"
        >
          {steps.map((step, index) => (
            <StepItem
              key={index}
              item={step}
              isMobile={isMobile}
              stepNumber={index + 1}
              reverse={index % 2 !== 0}
              bgColor={'bg-white'}
              primaryBtnClassName={primaryBtnClassName}
              primaryBtnName={primaryBtnName}
            />
          ))}
        </SlickSlider>
      )}
    </section>
  )
}

export default React.memo(FiveSteps)

FiveSteps.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      stepTitle: PropTypes.string,
      stepDescription: PropTypes.string,
      img: PropTypes.shape({
        desktop: PropTypes.shape({
          src: PropTypes.string,
          alt: PropTypes.string,
        }),
        mobile: PropTypes.shape({
          src: PropTypes.string,
          alt: PropTypes.string,
        }),
        about: PropTypes.string,
      }),
      showButton: PropTypes.bool,
    })
  ),
  primaryBtnClassName: PropTypes.string,
  primaryBtnName: PropTypes.string,
}
